import type { InventoryVehicle } from '@carvana/merch-contracts';

function isDefined<T>(input: T | undefined | null): input is T {
  return typeof input !== 'undefined' && input !== null;
}

/**
 * Favorites API returns vehicles with the most recently favorited first, so we
 * need to sort the vehicles returned from search to match that order.
 */
export default function sortVehiclesByRecency(
  vehicleFromSearch: InventoryVehicle[],
  vehicleIdsFromFavorites: number[]
) {
  const vehicleMap = vehicleFromSearch.reduce<Record<number, InventoryVehicle>>(
    (acc, vehicle) => {
      acc[vehicle.vehicleId] = vehicle;

      return acc;
    },
    {}
  );

  return vehicleIdsFromFavorites.map(id => vehicleMap[id]).filter(isDefined);
}
